module.exports = __webpack_public_path__ + "static/img/zd04.4c60277b.svg";